import * as React from 'react';
import ChatBot from '../../../components/bot/ChatBot';
import { Alert } from "reactstrap";
import { ThemeProvider } from 'styled-components';
import TestPositionButtons from './PositionAnswer';
import QuadroTestAnswer from './QuadroAnswer';
import CanTestAnswer from './CanAnswer';
import CanCheck from './CanCheck';
import StartStep, { withReset } from './StartStep';
import { LockTestCommand, LockTestCommandVerify } from './BloccoAnswer';
import { YesNoQuestion } from './index';
import { useAuth0 } from '../../../auth/react-auth0-wrapper'
import logo from "../../../assets/logo-piramis.png"


const START_STEP = 'start';
const TestPosition = withReset(
    TestPositionButtons,
    START_STEP,
    'TEST POSIZIONE'
);
const TestQuadro = withReset(
    QuadroTestAnswer,
    START_STEP,
    'TEST QUADRO'
);
const TestCan = withReset(
    CanTestAnswer,
    START_STEP,
    'TEST LINEA CAN'
);
const LockCommand = withReset(
    LockTestCommand,
    START_STEP,
    'TEST BLOCCO'
);

const VerifyLockCommand = withReset(
    LockTestCommandVerify,
    START_STEP,
    'TEST BLOCCO'
);

const theme = {
    background: '#DAE1E7',
    fontFamily: 'Helvetica Neue',
    headerBgColor: '#116bf5',
    headerFontColor: '#fff',
    headerFontSize: '16px',
    botBubbleColor: '#7a7c93',
    botFontColor: '#fff',
    userBubbleColor: '#7FBCEC',
    userFontColor: '#000'
};

export default function CollaudoBot({
    deviceId,
    onCollaudoEnd,
    onSaveCollaudo,
    collaudoId,
    noCanTest,
    canCodeId
}) {
    if (!deviceId) return null;
    const { domains } = useAuth0();
    return (
        <div className="p-grid w-full">
            <div className="p-col-12">
                <ThemeProvider theme={theme}>
                    <ChatBot
                        botAvatar={logo}
                        headerTitle='Flusso di collaudo'
                        speechSynthesis={{ enable: false, lang: 'it' }}
                        inputAttributes={{ style: { display: 'none' } }}
                        bubbleStyle={{ maxWidth: 'unset' }}
                        hideSubmitButton
                        cache
                        cacheName={collaudoId}
                        enableMobileAutoFocus
                        style={{
                            width: '100%',
                            zIndex: '0',
                            height: '365px',
                            fontFamily: 'unset'
                        }}
                        handleEnd={onCollaudoEnd}
                        contentStyle={{ height: '300px', padding: '10px' }}
                        steps={[
                            {
                                id: START_STEP,
                                component: (
                                    <StartStep
                                        triggerPosition="test-posizione-start"
                                        triggerCan="test-can-start"
                                        triggerQuadro="test-quadro-start"
                                        triggerBlocco="test-blocco-start"
                                        endPosition="test-posizione-end"
                                        endCan="test-can-end"
                                        endQuadro="test-quadro-end"
                                        endBlocco="test-blocco-end"
                                        onSaveCollaudo={onSaveCollaudo}
                                        finalBlock="collaudo-end"
                                        deviceId={deviceId}
                                        noCanTest={noCanTest}
                                    />
                                ),
                                waitAction: true,
                                replace: true,
                                asMessage: true,
                                hideInput: true
                            },
                            {
                                id: 'test-posizione-start',
                                trigger: 'test-posizione',
                                message: `Accertarsi che il sistema rilevi le posizioni in tempo reale. Il numero dei satelliti deve essere superiore alla soglia minima di ${
                                    domains.appSettings.satLimit
                                    }.`,
                                hideInput: true
                            },
                            {
                                id: 'test-posizione',
                                hideInput: true,
                                component: <TestPosition trigger="test-posizione-end" deviceId={deviceId} />,
                                waitAction: true,
                                asMessage: true
                            },
                            {
                                id: 'test-posizione-end',
                                hideInput: true,
                                component: (
                                    <Alert
                                        color="success"
                                        title='TEST POSIZIONE COMPLETATO!'
                                    ><p>TEST POSIZIONE COMPLETATO!</p></Alert>
                                ),
                                asMessage: true,
                                trigger: START_STEP
                            },                            
                            {
                                id: 'test-can-start',
                                trigger: 'test-can-check',
                                message: `Accendere il motore del veicolo ed attendere qualche secondo per effettuare il controllo presenza del modulo CAN`,
                                hideInput: true
                            },
                            {
                                id: 'test-can-check',
                                hideInput: true,
                                component: <CanCheck trigger="test-can-sent" deviceId={deviceId} canCodeId={canCodeId}/>,
                                waitAction: true,
                                asMessage: true
                            },
                            {
                                id: 'test-can-sent',
                                trigger: 'test-can',
                                message: `Controllo presenza del modulo CAN effettuato. Prossimo test: rilevamento corretta installazone CAN e dati`,
                                hideInput: true
                            },
                            {
                                id: 'test-can',
                                hideInput: true,
                                component: <TestCan trigger="test-can-end" deviceId={deviceId}/>,
                                waitAction: true,
                                asMessage: true
                            },
                            {
                                id: 'test-can-end',
                                hideInput: true,
                                component: (
                                    <Alert
                                        color="success"
                                        title='TEST LINEA CAN COMPLETATO!'
                                    ><p>TEST LINEA CAN COMPLETATO!</p></Alert>
                                ),
                                asMessage: true,
                                trigger: START_STEP
                            },
                            {
                                id: 'test-quadro-start',
                                hideInput: true,
                                message: `Il test del quadro serve per verificare che lo stato del quadro del veicolo (acceso, spento) coincida con quello rilevato. Si prega di accendere il quadro del veicolo, attendere qualche istante e verificare.`,
                                trigger: 'test-quadro-on'
                            },
                            {
                                id: 'test-quadro-on',
                                hideInput: true,
                                waitAction: true,
                                component: (
                                    <TestQuadro verify="on" trigger="test-quadro-on-ok" deviceId={deviceId} />
                                ),
                                asMessage: true
                            },
                            {
                                id: 'test-quadro-on-ok',
                                hideInput: true,
                                message: `Lo stato segnalato corrisponde con quello rilevato!`,
                                trigger: 'test-quadro-off-desc'
                            },
                            {
                                id: 'test-quadro-off-desc',
                                hideInput: true,
                                message: `Si prega di spegnere il quadro del veicolo e di verificare.`,
                                trigger: 'test-quadro-off'
                            },
                            {
                                id: 'test-quadro-off',
                                hideInput: true,
                                waitAction: true,
                                component: (
                                    <TestQuadro verify="off" deviceId={deviceId} trigger="test-quadro-off-ok" />
                                ),
                                asMessage: true
                            },
                            {
                                id: 'test-quadro-off-ok',
                                hideInput: true,
                                message: `Lo stato segnalato corrisponde con quello rilevato!`,
                                trigger: 'test-quadro-end'
                            },
                            {
                                id: 'test-quadro-end',
                                hideInput: true,
                                component: (
                                    <Alert
                                        color="success"
                                        title='TEST QUADRO COMPLETATO!'><p>TEST QUADRO COMPLETATO!</p></Alert>
                                ),
                                asMessage: true,
                                trigger: START_STEP
                            },
                            {
                                id: 'test-blocco-start',
                                hideInput: true,
                                message: `Si prega di accendere il motore della vettura ed attendere qualche secondo. Procedere poi con il test di blocco.`,
                                trigger: 'test-blocco-1'
                            },
                            {
                                id: 'test-blocco-1',
                                hideInput: true,
                                component: (
                                    <LockCommand
                                        deviceId={deviceId}
                                        trigger="test-blocco-1-verify"
                                        command="lock"
                                    />
                                ),
                                waitAction: true,
                                asMessage: true
                            },
                            {
                                id: 'test-blocco-1-verify',
                                hideInput: true,
                                waitAction: true,
                                component: (
                                    <VerifyLockCommand
                                        deviceId={deviceId}
                                        trigger="test-blocco-1-ignition-stopped"
                                        verify="lock"
                                    />
                                ),
                                asMessage: true
                            },
                            {
                                id: 'test-blocco-1-ignition-stopped',
                                hideInput: true,
                                message: `Provare ad avviare il motore. Con il dispositivo in stato di blocco il veicolo NON deve mettersi in moto. Confermi il blocco del motore?`,
                                trigger: 'test-blocco-1-ignition-stopped-answer'
                            },
                            {
                                id: 'test-blocco-1-ignition-stopped-answer',
                                hideInput: true,
                                waitAction: true,
                                component: (
                                    <YesNoQuestion
                                        question='Il motore si trova in stato di blocco e non si accende?'
                                        yesTrigger="test-sblocco-1"
                                        noTrigger="test-blocco-1-ignition-stopped-failure"
                                        yesLabel='SI IL MOTORE É BLOCCATO'
                                        noLabel='NO, RIPETI LA VERIFICA'
                                    />
                                ),
                                asMessage: true
                            },
                            {
                                id: 'test-blocco-1-ignition-stopped-failure',
                                hideInput: true,
                                component: (
                                    <Alert
                                        color="danger"
                                        title='Errore verifica blocco/sblocco motore'
                                    >   <p>Test fallito. Si prega di verificare l’installazione (Blocco Avviamento +50) per poi ripetere il test.
                                    </p></Alert>
                                ),
                                asMessage: true,
                                trigger: 'test-blocco-start'
                            },
                            {
                                id: 'test-sblocco-1',
                                hideInput: true,
                                component: (
                                    <LockCommand
                                        deviceId={deviceId}
                                        trigger="test-sblocco-1-verify"
                                        command="unlock"
                                    />
                                ),
                                waitAction: true,
                                asMessage: true
                            },
                            {
                                id: 'test-sblocco-1-verify',
                                hideInput: true,
                                waitAction: true,
                                component: (
                                    <VerifyLockCommand
                                        deviceId={deviceId}
                                        trigger="test-sblocco-1-ignition-on"
                                        verify="unlock"
                                    />
                                ),
                                asMessage: true
                            },
                            {
                                id: 'test-sblocco-1-ignition-on',
                                hideInput: true,
                                message: 'Provare ad avviare il motore. Con il dispositivo in stato di sblocco il veicolo DEVE mettersi in moto. Confermi la messa in moto?',
                                trigger: 'test-sblocco-1-ignition-on-answer'
                            },
                            {
                                id: 'test-sblocco-1-ignition-on-answer',
                                hideInput: true,
                                waitAction: true,
                                component: (
                                    <YesNoQuestion
                                        question='Il motore si accende correttamente?'
                                        yesTrigger="test-blocco-end"
                                        noTrigger="test-blocco-1-ignition-stopped-failure"
                                        yesLabel='SI IL MOTORE SI É ACCESO'
                                        noLabel='NO, RIPETI LA VERIFICA'
                                    />
                                ),
                                asMessage: true
                            },
                            {
                                id: 'test-blocco-end',
                                hideInput: true,
                                component: (
                                    <Alert
                                        color="success"
                                        title='TEST BLOCCO COMPLETATO!'
                                    ><p>TEST BLOCCO COMPLETATO!</p></Alert>
                                ),
                                asMessage: true,
                                trigger: START_STEP
                            },
                            {
                                id: 'collaudo-end',
                                hideInput: true,
                                message: 'COLLAUDO TERMINATO CORRETTAMENTE.',
                                end: true
                            }
                        ]}
                    />
                </ThemeProvider>
            </div>
        </div>
    );
}
